import { render, staticRenderFns } from "./CRPermissions.vue?vue&type=template&id=1b97c7d2&"
import script from "./CRPermissions.vue?vue&type=script&lang=js&"
export * from "./CRPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports